import { createSlice } from "@reduxjs/toolkit";

export const startsSimulation = createSlice({
  name: "startsSimulation",
  initialState: null,
  reducers: {
    setData: (state, action) => action.payload,
  },
});

export const selectors = {
  get: (state) => state.startsSimulation,
};
